const THEME = "Light";
const ISSUE = 3;
const YEAR = 2021;
const DESC =
  "Texts on light and lightness by Nexo’s writers explore parenthood, prejudice, and courageousness";
const BACKGROUND = "#000000";
const FOREGROUND = "#ffffff";

const appConfig = {
  theme: THEME,
  issue: ISSUE,
  year: YEAR,
  title: `${THEME} | Nexo ${ISSUE}/${YEAR}`,
  description: `${DESC}. Read thought-provoking texts by a diverse community of writers.`,
  keywords: `Nexo, Nexo Creative Writing, Nexo Creative Writing group, Nexo Zine, Helsinki, emigration, migrant, literary magazine, writer's group, creative writing, luova kirjoittaminen, storytelling, tarinankerronta, writing workshop, kirjoittamisen työpaja, community, yhteisö, ${THEME}`,
  icon: "static/favicon.svg",
  backgroundColor: BACKGROUND,
  foregroundColor: FOREGROUND,
  url: `https://nexo${ISSUE}.netlify.app/`,
  author: "Nexo Creative Writing",
  requireAuth: false,
  hideFromSearchEngines: false,
  googleAnalyticsId: "G-HKTRN36RJ8",
  otherIssues: [
    {
      title: "1/2020 - Mirrors",
      url: "https://issuu.com/nexocreativewriting/docs/issuuoriginalnexozineedit03122020",
    },
    {
      title: "2/2021 - Roots",
      url: "https://nexo2.netlify.app/",
    },
  ],
};

module.exports = appConfig;
